import React from 'react';
import PropTypes from 'prop-types';
import CalciteLoader from './CalciteLoader';
import i18nService from '@/services/i18n/i18n-service';

/**
 * @typedef {Object} PageLoaderProps
 * @property {boolean} [fullWidth] - Render at full width instead of inside the grid container.
 */
const PageLoader = ({fullWidth = false}) => {
  const label = i18nService.t('Loading...');
  const loader = <CalciteLoader text={label} label={label} type="indeterminate" />;

  if (fullWidth) {
    return (
      <div data-testid="page-loader" style={{minWidth: '100%'}}>
        {loader}
      </div>
    );
  }

  return (
    <div data-testid="page-loader" className="grid-container">
      <div className="column-24 phone-column-6 tablet-column-12 tablet-leader-1">{loader}</div>
    </div>
  );
};

PageLoader.propTypes = {
  fullWidth: PropTypes.bool,
};

export default PageLoader;
